module.exports = "<div class=\"modal sb-modal\" tabindex=-1 role=dialog> <div class=modal-dialog> <div class=\"modal-content panel\"> <div class=\"panel-header modal-header\"> <div class=row> <div class=col-md-9> <h3 class=panel-title style=text-align:left>{{ ::$ctrl.title }}</h3> </div> <div class=col-md-3> <div ng-transclude=header></div> </div> </div> </div> <div class=\"panel-body modal-body\"> <div ng-transclude=content></div> </div> <div class=\"panel-footer modal-footer\"> <div ng-transclude=actions></div> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal/modal.html
// module id = 228
// module chunks = 0